import React, { memo } from 'react';
import { injectIntl } from 'react-intl';
import { Card, CardHeader, CardContent, Divider, Grid, Typography } from '@mui/material';
import HubIcon from '@mui/icons-material/Hub';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { getChartColors } from '../../../../utils/chartTheme';

const ChannelDonut = memo(function ChannelDonut(props) {
  const { data, intl } = props;
  const colors = getChartColors();

  const chartData = (data || []).map(item => ({
    name: item.originrequestname,
    value: item.count || 0
  }));
  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        avatar={<span style={{ color: colors.warning, display: 'flex' }}><HubIcon /></span>}
        title={intl.formatMessage({ id: 'agentproductivity.dashboard.bychannel.title', defaultMessage: 'Atendimentos por canal' })} />
      <Divider />
      <CardContent>
        <Grid container alignItems="center">
          <Grid item xs={12} md={7}>
            <div style={{ width: '100%', height: 260 }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={chartData} dataKey="value" nameKey="name" innerRadius={60} outerRadius={90} isAnimationActive={false}>
                    {chartData.map((entry, index) => (
                      <Cell
                        key={`channel-cell-${index}`}
                        fill={colors.categorical[index % colors.categorical.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </Grid>
          <Grid item xs={12} md={5}>
            <Typography variant="h4" align="center">{total}</Typography>
            <Typography variant="caption" color="textSecondary" display="block" align="center" gutterBottom>
              {intl.formatMessage({ id: 'agentproductivity.dashboard.bychannel.total', defaultMessage: 'atendimentos' })}
            </Typography>
            {chartData.map((item, index) => (
              <Grid
                container
                key={`channel-legend-${index}`}
                justifyContent="space-between"
                style={{ marginTop: 4 }}
              >
                <Grid item>
                  <span
                    className="mexx-dyn-bg"
                    style={{
                      display: 'inline-block', width: 10, height: 10, borderRadius: 2, marginRight: 6,
                      '--mexx-dyn-bg': colors.categorical[index % colors.categorical.length]
                    }}
                  />
                  <Typography variant="body2" component="span">{item.name}</Typography>
                </Grid>
                <Grid item>
                  <Typography variant="body2" component="span">
                    {item.value} ({total > 0 ? Math.round((item.value / total) * 100) : 0}%)
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
});

export default injectIntl(ChannelDonut);
